export default __webpack_public_path__ + "static/media/Q2_4.dfbb7ae3.png";